"use client";

import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  _src = "/images/raiqa-connect-logo.png",
  theme = "light",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  _src?: string;
  theme?: string;
}) {
  const logoSrc = "/images/raiqa-connect-logo.png";

  const isConnectLogo = logoSrc === "/images/raiqa-connect-logo.png";

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img
            className="mx-auto w-9 dark:invert"
            alt="Raiqa Health"
            title="Raiqa Health"
            src={logoSrc}
          />
        ) : (
          <img
            className={classNames(
              small ? "h-auto w-auto" : isConnectLogo ? "h-10 w-auto" : "h-24 w-auto",
              "dark:invert"
            )}
            alt="RaiqaHealth"
            title="Raiqa Health"
            src={logoSrc}
          />
        )}
      </strong>
    </h3>
  );
}
